__turbopack_context__.v({
  "animate-bottom": "mini-popover-module-scss-module__q4Yf5W__animate-bottom",
  "close-button": "mini-popover-module-scss-module__q4Yf5W__close-button",
  "close-button-icon": "mini-popover-module-scss-module__q4Yf5W__close-button-icon",
  "container": "mini-popover-module-scss-module__q4Yf5W__container",
  "end": "mini-popover-module-scss-module__q4Yf5W__end",
  "entered": "mini-popover-module-scss-module__q4Yf5W__entered",
  "entering": "mini-popover-module-scss-module__q4Yf5W__entering",
  "exited": "mini-popover-module-scss-module__q4Yf5W__exited",
  "exiting": "mini-popover-module-scss-module__q4Yf5W__exiting",
  "full": "mini-popover-module-scss-module__q4Yf5W__full",
  "header": "mini-popover-module-scss-module__q4Yf5W__header",
  "main": "mini-popover-module-scss-module__q4Yf5W__main",
  "mini-popover": "mini-popover-module-scss-module__q4Yf5W__mini-popover",
  "start": "mini-popover-module-scss-module__q4Yf5W__start",
  "title": "mini-popover-module-scss-module__q4Yf5W__title",
});
